import axios from "axios";
import env from "../../constants/apiConst";

/**
 * Caso 1032: consulta las coincidencias de un FORMULARIO con la lista de
 * proveedores ficticios. Se usa antes de un cambio de estado, donde la pantalla
 * no siempre tiene cargados los nombres del formulario; el backend los resuelve
 * desde la base de datos y respeta la restricción de los usuarios DIAN.
 */
export const __CheckFictitiousFormSimilarity = async (token, formType, formId) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: { form_type: formType, form_id: formId }
  };

  const res = await axios(env.CHECK_FICTITIOUS_FORM_SIMILARITY, options);
  return res;
};
